// i18n.js
import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    header: 'Tyre Warranty Plan Registration',
    contactInfo: 'Contact Information',
    purchaseInfo: 'Purchase Details',
    title: 'Title',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    carLicensePlate: 'Car License Plate',
    tyrePattern: 'Tyre Pattern',
    tyreSize: 'Tyre Size',
    tyreQuantity: 'Choose the number of purchased tyres',
    purchaseDate: 'Purchase date',
    purchaseReceipt:'Purchase Receipt',
    page1:'Page 1',
    page2:'Page 2',
    terms: 'I have read, understood and accepted the details and the terms of the extra warranty.',
    submit: 'Register',
    language: 'Language',
    invalidEmail: 'Invalid Email Format',
    required: 'Required',
    contact: 'Error submitting form. Please try again or contact staff for help',
    mr:'Mr',
    mrs:'Mrs',
    miss:'Miss',
    missingPurchaseDate:'Missing Purchase Date',
    tyreInfo: 'This tyre is an official genuine product authorized by MICHELIN and distributed by THE HONGKONG CANTON EXPORT CO., LTD. (HOCAN) ',
    noTyreRecord: 'No Tyre Record',
    error: 'Error',
    registerTyre: 'Purchased. Click here to register and enjoy 100 days of road accident protection.',
    ok: 'OK',
    errorFetchingTyreInfo: 'Error fetching tyre information',
    width: 'Width',
    ratio: 'Ratio',
    diameter: 'Diameter',
    loadIndex: 'Load Index',
    speedIndex: 'Speed Index',
    tireSize: 'Tire Size',
    modelSizeIs: 'The model size is',
    moreInfo: 'More information about this tyre',
    register: 'Purchased. Click here to register and enjoy 100 days of road accident protection.',
    termsAndConditions: 'Rules and terms of 100-day road accident protection',
    whyBuy: 'Claim Procedure',
    purchasedTyreSize: 'The purchased tyre size is',
    scanAdditionalQRCodes: 'Please enter the ID below the QR Code',
    tyre: 'Tyre',
    scanQRCode: 'Id',
    upload: 'Upload',
    duplicateQRCode: 'QR Code already uploaded',
    invalidQRCode: 'Invalid QR Code',
    uploadError: 'Upload failed',
    uploadSuccess: 'Upload successful',
    uploadFailed: 'Upload failed',
    notScanned: 'QR Code not scanned',
    serverError: 'Server error',
    noResponse: 'Server no response',
    errorMessage: 'Error message',
    registrationSuccess: 'Registration completed',
    registrationReferenceNumber: 'Your registration is being reviewed, we will contact you when necessary via email/phone',
    registrationFailed: 'Registration failed, please contact staff for help',
    tyreAlreadyRegistered: 'Tyre already registered',
    roadProtectionTitle: '100 days Road Accident Protection',
    roadProtectionText: 'When you purchase tyres from MICHELIN authorized channels or dealers (THE HONGKONG CANTON EXPORT CO., LTD.) and register on time, if a road hazard covered by this protection policy damages the tyre beyond repair and the tyre can no longer be used normally, you may apply for compensation and exchange it free of charge for a new Michelin tyre of the same specification and tread pattern. (The damaged tyre must be handed in when collecting the new tyre.)',
    search: 'Search',
    searchRegistration: 'Search registered tyres to apply for compensation',
    claimRequest: 'Claim Request',
    uploadPhotos: 'Tyre damage photos',
    submitClaim: 'Submit Claim',
    errorFetchingData: 'No related purchase or purchase time exceeds 100 days, please contact 98680758 for assistance',
    claimSubmittedSuccessfully: 'Your application is being processed, we will contact you as soon as possible',
    notGuaranteeClaim: 'Note: The application is still being processed and does not mean that the claim has been confirmed',
    contactUs: 'For assistance, please call 98680758',
    claimReviewTitle: 'Claim Review',
    searchClaim: 'Search Claim',
    tyreImage: 'Tyre Image',
    searchClaimPlaceholder: 'Please enter the car license plate/phone/email',
    tyreModelAndSize: 'Tyre Model and Size',
    close: 'Close',
    claimTitle: 'Claim',
    newTyre: 'Confirm',
    invalidPhone: 'Invalid phone number',
    missingPurchaseReceipt: 'Please upload the purchase receipt',
    dealerName: 'Dealer Name',
  },
  zh: {
    header: '輪胎保固計劃登記',
    contactInfo: '聯絡方式',
    purchaseInfo: '購買詳情',
    title: '稱謂',
    name: '姓名',
    email: '電郵信箱',
    phone: '電話',
    carLicensePlate: '車牌號碼',
    tyrePattern: '輪胎型號',
    tyreSize: '輪胎尺寸',
    tyreQuantity: '選擇已購買輪胎數量',
    purchaseDate: '購買日期',
    purchaseReceipt:'購買收據',
    page1:'第一頁',
    page2:'第二頁',
    terms: '我已閲讀、理解並接受額外保固的詳細信息和條款。',
    submit: '登記',
    language: '語言',
    invalidEmail: '電郵格式不正確',
    required: '必需填寫',
    contact: '提交錯誤。請重試或聯絡職員協助',
    mr:'先生',
    mrs:'太太',
    miss:'小姐',
    missingPurchaseDate:'請填寫購買日期',
    tyreInfo: '此輪胎為 MICHELIN 米芝蓮官方授權 （新志利洋行有限公司）的正行貨輪胎',
    noTyreRecord: '找不到輪胎',
    error: '錯誤',
    registerTyre: '已購買，按此註冊享有100天 道路意外保障',
    ok: '確定',
    errorFetchingTyreInfo: '獲取輪胎信息時出錯',
    width: '寬度',
    ratio: '扁平比',
    diameter: '直徑',
    loadIndex: '負荷指數',
    speedIndex: '速度級別',
    tireSize: '輪胎尺寸',
    modelSizeIs: '型號尺寸是',
    moreInfo: '更多有關此輪胎的資訊',
    register: '已購買，按此註冊享有100天 道路意外保障',
    termsAndConditions: '100天 道路意外保障的規則與條款',
    whyBuy: '索償程序',
    purchasedTyreSize: '已購買輪胎型號尺寸是',
    scanAdditionalQRCodes: '請輸入二維碼下方的數碼​',
    tyre: '輪胎',
    scanQRCode: '數碼​',
    upload: '上傳',
    duplicateQRCode: '重複數碼​',
    invalidQRCode: '無效數碼​',
    uploadError: '上傳失敗',
    uploadSuccess: '上傳成功',
    uploadFailed: '上傳失敗',
    notScanned: '二維碼未掃描',
    serverError: '伺服器錯誤',
    noResponse: '伺服器無回應',
    errorMessage: '錯誤訊息',
    registrationSuccess: '註冊已完成',
    registrationReferenceNumber: '你的登記正在覆核，有需要時會與您Email/電話聯絡',
    registrationFailed: '註冊失敗, 請聯絡職員協助',
    tyreAlreadyRegistered: '輪胎已經登記',
    roadProtectionTitle: '100天道路意外保障',
    roadProtectionText: '在米芝蓮官方授權 （新志利洋行有限公司）的渠道或經銷商購買輪胎並按時註冊，發生本保障政策範圍內的道路問題而導致的輪胎損壞，並無可能收補，造成輪胎無法正常使用的，則消費者可進行補償申請，免費兌換一條同等規格和花紋的米芝蓮新胎。（需提供損壞輪胎兌換新胎）',
    search: '搜尋',
    searchRegistration: '搜尋已註冊輪胎以申請賠償',
    claimRequest: '申請賠償',
    uploadPhotos: '輪胎損壞的照片',
    submitClaim: '確認申請賠償',
    errorFetchingData: '找不到相關購買或購買時間超過 100 天, 如需協助請致電 98680758',
    claimSubmittedSuccessfully: '您的申請正在辦理, 我們將盡快與您聯繫',
    notGuaranteeClaim: '備註: 申請正在進行中，但並不表示索賠已被確認',
    contactUs: '如需協助請致電 98680758',
    claimReviewTitle: '賠償申請審核',
    searchClaim: '搜尋賠償申請',
    searchClaimPlaceholder: '請輸入車牌號碼/電話/電郵',
    tyreImage: '輪胎圖片',
    tyreModelAndSize: '輪胎型號及尺寸',
    failedToFetchData: '獲取輪胎賠償數據失敗，請重試',
    noTyreClaimDataFound: '找不到輪胎賠償數據',
    invalidDate: '無效日期',
    notAvailable: 'N/A',
    close: '關閉',
    claimTitle: '賠償申請',
    newTyre: '確認​',
    invalidPhone: '無效電話號碼',
    missingPurchaseReceipt: '請上傳購買收據',
    dealerName: '輪胎店名稱',
  }
};

const i18n = createI18n({
  locale: 'zh',
  messages,
});

export default i18n;
